module.exports = __webpack_public_path__ + "assets/img/title-83448f68.png";